if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      get selectedOptionMainValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(el => el.value || el.textContent.trim());
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);

          var productVariants_json = document.querySelector('.product-inventory-data').getAttribute('data-product-json');
          var productVariants = JSON.parse(productVariants_json);


          var preorderIDs = document.querySelector('.product__inventory.main-pre').getAttribute('data-pre-ids');
          var MainSubmitButton = document.querySelector('.main-product .main-product-form .product-form__submit span');
          var MainSubmitButton_normal_txt = MainSubmitButton.getAttribute('data-main-text');
          var MainSubmitButton_pre_txt = MainSubmitButton.getAttribute('data-other-text');

          let is_pre_order = false;
          let is_out_of_stock = false;
          let is_normal = false;

        
            var matchedVariant = productVariants.find(variant => {
              return JSON.stringify(variant.options) === JSON.stringify(this.selectedOptionMainValues);
            });
          

            document.querySelectorAll('.product__inventory').forEach(function(el) {
                el.classList.remove('active');
            });

            // console.log(matchedVariant);
            // console.log(productVariants);

            if(matchedVariant != undefined){

            // console.log(matchedVariant);
            // console.log(matchedVariant.available);

              if(!matchedVariant.available){
                is_out_of_stock = true;
              }else{
                if (preorderIDs.includes(matchedVariant.id)) {
                  is_pre_order = true;
                } else {
                  is_normal = true;
                }
              }

              const MainDiv = document.querySelector('.product__inventory.main-default');
              if (MainDiv && is_normal) {
                MainDiv.classList.add('active');  
              }

              const MainOutDiv = document.querySelector('.product__inventory.main-out-of-stock');
              if (MainOutDiv && is_out_of_stock) {
                MainOutDiv.classList.add('active');  
              }

              const MainPreDiv = document.querySelector('.product__inventory.main-pre');
              if (MainPreDiv && is_pre_order) {
                MainPreDiv.classList.add('active'); 
              }

              if(is_pre_order && MainSubmitButton_pre_txt != ""){
                MainSubmitButton.classList.add('custom-btn-text');
                MainSubmitButton.style.setProperty('--text-var', `"${MainSubmitButton_pre_txt}"`);
              }else{
                MainSubmitButton.style.setProperty('--text-var', `"${MainSubmitButton_normal_txt}"`);
              }
            }else{
              const MainUnavailableDiv = document.querySelector('.product__inventory.main-unavailable');
              if (MainUnavailableDiv) {
                MainUnavailableDiv.classList.add('active');  
              }
               MainSubmitButton.style.setProperty('--text-var', '"EJ TILLGÄNGLIG"');
            }

            // var get_option_id = this.selectedOptionValues;
            // var inputElement = document.querySelector('.tyngdedyne-voksen .main-product .main-product-form input[name="id"]');
            // if (inputElement) {   
            //     var submitButton = document.querySelector('.tyngdedyne-voksen .main-product .main-product-form .product-form__submit span');
            //     // console.log(get_option_id[0]);
            //     if (submitButton) {
            //         if (get_option_id[0] == 870867304773 && get_option_id[1] == 38721651013) {
            //             submitButton.style.setProperty('--text-var', '"Tilføj til kurv"');
            //         } else if(get_option_id[0] == 38721487173 && get_option_id[1] == 38721651013) {
            //             submitButton.style.setProperty('--text-var', '"IKKE TILGÆNGELIG"');
            //         }else {
            //             submitButton.style.setProperty('--text-var', '"FORUDBESTIL - D. 15 MARTS"');
            //         }
            //     }
            // }
          
            // var mainElement = document.querySelector('.main-product').getAttribute('data-product-id');
            // if(mainElement == "9888461881671"){
            //   const wrapper = document.querySelector('.product-inventory-new .product__inventory');
            //   const textElement = document.querySelector('.product-inventory-new .product__inventory-text');
            //   var submitButton = document.querySelector('.main-product[data-product-id="9888461881671"] .main-product-form .product-form__submit span');
            //   if(get_option_id[0] == '4427991351623')  {
                   
            //       textElement.innerHTML = 'Förbeställning.<span class="black-text"> Beräknad leverans från 31/1.</span>';
            //       // textElement.innerHTML = 'Udsolgt.';
            //       submitButton.style.setProperty('--text-var', '"FÖRBESTÄLL HÄR"');
            //       wrapper.setAttribute('data-pre-ids', '50741936259399');
            //   // }else if(get_option_id[0] == '4427991253319' || get_option_id[0] == '4427991318855')  {
                   
            //   //     textElement.innerHTML = 'Förbeställning.<span class="black-text"> Leverans från 1. november 2025.</span>';
            //   //     // textElement.innerHTML = 'Udsolgt.';
            //   //     submitButton.style.setProperty('--text-var', '"FÖRBESTÄLL HÄR"');
            //   }else{
            //       wrapper.setAttribute('data-pre-ids', '');
            //       wrapper.classList.remove('product__inventory--out-of-stock');
            //       wrapper.classList.add('product__inventory--in-stock');
                
            //       textElement.innerHTML = 'I lager.<span class="black-text"> 2-4 dagars leverans </span>';
               
            //       submitButton.style.setProperty('--text-var', '"Lägg till i kundvagn"');
            //   }


            //   console.log(get_option_id[0]);
            // }

            // if(mainElement == "9893595939143-1"){
            //   const wrapper = document.querySelector('.product-inventory-new .product__inventory');
            //   const textElement = document.querySelector('.product-inventory-new .product__inventory-text');
            //   var submitButton = document.querySelector('.main-product[data-product-id="9893595939143"] .main-product-form .product-form__submit span');
            //   if(get_option_id[0] == '4600693260615')  {
                   
            //       textElement.innerHTML = 'Förbeställning.<span class="black-text"> Levereras den 20 oktober.</span>';
            //       // textElement.innerHTML = 'Udsolgt.';
            //       submitButton.style.setProperty('--text-var', '"FÖRBESTÄLL HÄR"');
            //   }else{
                
            //       wrapper.classList.remove('product__inventory--out-of-stock');
            //       wrapper.classList.add('product__inventory--in-stock');
                
            //       textElement.innerHTML = 'I lager.<span class="black-text"> 2-4 dagars leverans </span>';
               
            //       submitButton.style.setProperty('--text-var', '"Lägg till i kundvagn"');
            //   }


            //   console.log(get_option_id[0]);
            // }

            // if(mainElement == "8430823145799"){
            //   const wrapper = document.querySelector('.product-inventory-new .product__inventory');
            //   const textElement = document.querySelector('.product-inventory-new .product__inventory-text');
            //   var submitButton = document.querySelector('.main-product[data-product-id="8430823145799"] .main-product-form .product-form__submit span');
            //   if(get_option_id[0] == '578098528583' && get_option_id[1] == '578098659655' || get_option_id[0] == '578098528583' && get_option_id[1] == '578098692423' ||
            //     get_option_id[0] == '578098561351' && get_option_id[1] == '578098659655' || get_option_id[0] == '578098561351' && get_option_id[1] == '578098692423' ||
            //     get_option_id[0] == '578098594119' && get_option_id[1] == '578098659655' || get_option_id[0] == '578098594119' && get_option_id[1] == '578098692423' 
            //    )  {
                   
            //       textElement.innerHTML = 'Förbeställning.<span class="black-text"> Levereras den 20 oktober.</span>';
            //       // textElement.innerHTML = 'Udsolgt.';
            //       submitButton.style.setProperty('--text-var', '"FÖRBESTÄLL HÄR"');
            //   }else{
                
            //       wrapper.classList.remove('product__inventory--out-of-stock');
            //       wrapper.classList.add('product__inventory--in-stock');
                
            //       textElement.innerHTML = 'I lager.<span class="black-text"> 2-4 dagars leverans </span>';
               
            //       submitButton.style.setProperty('--text-var', '"Lägg till i kundvagn"');
            //   }


            //   console.log(get_option_id[0]);
            // }

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}